import { render, staticRenderFns } from "./freestyle-info.vue?vue&type=template&id=39524eef&scoped=true&"
import script from "./freestyle-info.vue?vue&type=script&lang=js&"
export * from "./freestyle-info.vue?vue&type=script&lang=js&"
import style0 from "./freestyle-info.vue?vue&type=style&index=0&id=39524eef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39524eef",
  null
  
)

export default component.exports